import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import { EventManagerService } from '../common/service/event-manager.service';
import { Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Constant } from "../common/constant";
declare let $: any;

@Component({
  selector: "progress-loading-api",
  templateUrl: "./progress-loading-api.html",
  styleUrls: ["progress-loading-api.scss"]
})

export class ProgressLoadingAPI implements OnInit {
  subscribe: Subscription;
  progresList: any[] = [];
  Constant = Constant;
  constructor(
    private activeModal: NgbActiveModal,
    private eventManager: EventManagerService,
  ) { }

  ngOnInit() {
    this.eventManager.subscribe('waiting-request', (res) => {
      const request = res.content || {};
      const index = this.progresList.findIndex(item => item.requestId === request.requestId);
      const findRequest = this.progresList[index];
      if (findRequest) {
        if (!request.isLoad) {
          this.progresList.splice(index , 1);
        }
      } else {
        if (request.isLoad) {
          request.requestName = API_MAPPING_NAME[request.request] || request.request;
          this.progresList.push(request);
        }
      }
    });
  }
}
const API_MAPPING_NAME = {
  // API EXPORT
  [Constant.api_get_change_profiles_export] : 'Xuất file danh sách hồ sơ thay đổi',
  [Constant.api_agent_export_transaction_history] : 'Xuất file danh sách lịch sử lệnh',
  [Constant.api_agent_register_sip_export] : 'Xuất file danh sách đăng ký SIP',
  [Constant.api_export_statistic_gold_transaction] : 'Xuất file danh sách thông kê vàng',
  [Constant.api_agent_transaction_detail_export] : 'Xuất file danh sách chi tiết lệnh',
  [Constant.api_get_profiles_export] : 'Xuất file danh sách hồ sơ nhà đầu tư',
  [Constant.api_asset_report_export] : 'Xuất file báo cáo tài sản',
  [Constant.api_export_calculate_fee_issuer] : 'Xuất file báo cáo phí cho tổ chức phát hành',
  [Constant.api_export_calculate_fee_partner] : 'Xuất file báo cáo phí cho đại lý',
  [Constant.api_export_list_investor] : 'Xuất file danh sách nhà đầu tư',
  [Constant.api_export_agent_orders] : 'Xuất file danh sách hồ sơ nhà đầu tư',
  [Constant.api_agent_transaction_detail_export_sip_hsbc] : 'Chi tiết lệnh (Xuất file SIP HSBC)',
  [Constant.api_agent_transaction_detail_export_vsd] : 'Chi tiết lệnh (Xuất file SIP HSBC)',
  [Constant.api_agent_transaction_detail_export_vsd_sip_daichi] : 'Chi tiết lệnh (Xuất file SIP HSBC)',
  [Constant.api_agent_transaction_detail_export_sr45_46] : 'Chi tiết lệnh (Xuất file SIP HSBC)',
  [Constant.api_agent_export_transaction_history] : 'Xuất file lịch sử giao dịch',
  [Constant.api_get_export_fatca] : 'Export Fatca',
  // API NORMAL
  [Constant.api_agent_orders] : 'Tải danh sách lệnh',
  [Constant.api_import_transaction] : 'Tạo mới danh sách lệnh vào hệ thống',
  [Constant.api_check_approve_status] : 'Kiểm tra danh sách lệnh vào hệ thống',
  [Constant.api_get_pending_profiles] : 'Hồ sơ chờ duyệt',
  [Constant.api_accept_profile] : 'Xác nhận hồ sơ',
  [Constant.api_approve_profile] : 'Duyệt hồ sơ',
  [Constant.api_remove_profile] : 'Xóa hồ sơ',
  [Constant.api_update_status_profile] : 'Cập nhật hồ sơ',
  [Constant.api_update_create_file_to_vsd] : 'Tạo file VSD',
  [Constant.api_update_update_to_vsd] : 'File chuyển lên VSD',
  [Constant.api_change_request_profile_approve] : 'Duyệt thay đổi thông tin',
  [Constant.api_change_request_profile_reject] : 'Từ chối thay đổi thông tin',
  [Constant.api_profile_reject] : 'Từ chối hồ sơ',
  [Constant.api_agent_register_sip_on_vsd] : 'Đăng ký SIP lên VSD',
  [Constant.api_agent_product_cancel_all] : 'Hủy tất cả lệnh',
  [Constant.api_agent_product_accept_all] : 'Xác nhận tất cả lệnh',
  [Constant.api_agent_product_accept] : 'Xác nhận lệnh',
  [Constant.api_agent_product_approve] : 'Duyệt lệnh',
  [Constant.api_agent_product_approve_all] : 'Duyệt tất cả lệnh',
  [Constant.api_agent_product_cancel_order] : 'Hủy lệnh',
  [Constant.api_agent_ekyc_log_list] : 'Danh sách EKYC',
  [Constant.api_agent_ekyc_manual_list] : 'Danh sách EKYC Manual',
  [Constant.api_agent_list_sign_document_update_profile] : 'Danh sách thông tin thay đổi cần ký',
  [Constant.api_agent_approve_sign_document_update_profile] : 'Duyệt hồ sơ cần ký thay đổi thông tin',
  [Constant.api_get_investor_profile_pending] : 'Danh sách hồ sơ cần chờ EKYC',
  [Constant.api_investors_list] : 'Danh sách nhà đầu tư',
  [Constant.api_asset_report] : 'Báo cáo tài sản',
  [Constant.api_get_calculate_fee_issuer] : 'Báo cáo phí',
  [Constant.api_agent_investor_change_name_list] : 'Danh sách nhà đầu tư thay đổi tên',
  [Constant.api_agent_approve_investor_change_name] : 'Chấp nhận thay đổi tên nhà đầu tư',
  [Constant.api_agent_order_list] : 'Danh sách lệnh',
  [Constant.api_agent_transaction_detail] : 'Danh sách chi tiết lệnh',
  [Constant.api_agent_transaction_history] : 'Danh sách lịch sử giao dịch',
  [Constant.api_agent_sip_register_list] : 'Danh sách đăng ký SIP',
  ['/agents/admin' + Constant.api_agent_query_vsd_reconcile] : 'Đối soát VSD',
  [Constant.api_agent_query_change_profile] : 'Danh sách thông tin thay đổi',
  [Constant.api_agent_nav_change_list] : 'Danh sách NAV',
  ['/agents/admin' + Constant.api_get_export_hsbcAgent] : 'Đối soát đại lý',
  ['/agents/admin' + Constant.api_get_export_hsbc_balance] : 'Upload cập nhật số dư đại lý',
  ['/agents/admin' + Constant.api_get_export_upload_r44] : 'Upload R44',
  ['/agents/admin' + Constant.api_get_export_hsbc_upload] : 'Upload HSBC',
  ['/agents/admin' + Constant.api_get_export_upload_reconlied] : 'Upload đối chiếu',
  ['/agents/admin' + Constant.api_get_export_vsd_upload] : 'Upload VSD',
  [Constant.api_change_request_profile_filter] : 'Tải danh sách thông tin thay đổi',
  [Constant.api_get_document_survey_ipo]: 'Khảo sát IPO',
  [Constant.api_get_approve_profiles]: 'Danh sách hồ sơ'
   
}